module.exports = __webpack_public_path__ + "media/night/263-e22a0d73.svg";